$(document).ready(() => {
  var container = $('#collectingProject')
  if (container.length <= 0) { return; }

  subscribeToProjectLiveCollectChannel(container);
});

export function subscribeToProjectLiveCollectChannel(container) {
  App.cable.subscriptions.create({
    channel: 'ProjectLiveCollectChannel',
    project_id: container.data('project-id'),
  },
  {
    received(data) {
      let isNewDesignInvestmentModalShown = document.getElementById('investmentModal')?.classList?.contains('show');
      let isCollectOverModalShown = document.getElementById('collectOverModal')?.classList?.contains('show');

      if (data['project_closed'] === true) {
        if (!isNewDesignInvestmentModalShown && !isCollectOverModalShown && container.data('reload-when-closed')) {
          window.location.reload();
        }
        return;
      }

      document.querySelectorAll('.js-collected-amount').forEach((el) => {
        el.innerText = data['collected_amount'];
      });

      document.querySelectorAll('.js-subscribers-count').forEach((el) => {
        el.innerText = data['subscribers_count'];
      });

      document.querySelectorAll('.js-subscribers-count-wording').forEach((el) => {
        el.innerText = data['subscribers_count_investor_wording'];
      });

      document.querySelectorAll('.js-subscribers-count-invest-wording').forEach((el) => {
        el.innerText = data['subscribers_count_invest_wording'];
      });

      document.querySelectorAll('.js-bar').forEach((el) => {
        el.style.width = data['percent_collected'] + '%';
      });

      document.querySelectorAll('.js-percent-collected').forEach((el) => {
        el.innerText = parseInt(data['percent_collected'], 10) + '%';
      });
    },
  })
};
